
  export default {
    name: 'CheckoutFail'
    // create logic for try again in the dashboard since you should already have account
  };
